import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import {
  TCreateCompanyRequest,
  TCreateCompanyResponse,
} from "./createCompany.schema";

export const createCompany = (axios: IAxiosInstance) => {
  return async (data: TCreateCompanyRequest) => {
    const response = await axios.noRetry.post<
      IApiResponse<TCreateCompanyResponse>
    >(`/api/createCompany`, data);

    const resData = response.data;

    if (resData.success) {
      return resData.data;
    }

    throw new Error("Something went wrong");
  };
};
